function getTextNodesPreserveWhitespace(node) {
  const textNodes = [];
  if (node.nodeType === Node.TEXT_NODE && node.nodeValue.trim()) {
    textNodes.push(node);
  } else if (node.nodeType === Node.ELEMENT_NODE) {
    for (let child of node.childNodes) {
      textNodes.push(...getTextNodesPreserveWhitespace(child));
    }
  }
  return textNodes;
}

// Function to localize myfonts.com URLs
function localizeMyfontsUrls(element, locale) {
  if (locale === 'en') return; // No need to localize for English
  else if(locale === 'pt-BR') return 'pt';
  
  
  const links = element.querySelectorAll('a[href*="myfonts.com"]');
  links.forEach(link => {
    const href = link.getAttribute('href');
    if (href && href.includes('myfonts.com')) {
      // Check if URL already has locale prefix
      const urlObj = new URL(href);
      const pathname = urlObj.pathname;
      
      // If URL doesn't already have locale prefix, add it
      if (!pathname.startsWith(`/${locale}/`) && !pathname.startsWith(`/${locale}`)) {
        // Insert locale after domain
        const newPathname = `/${locale}${pathname}`;
        urlObj.pathname = newPathname;
        link.setAttribute('href', urlObj.toString());
      }
    }
  });
}

async function translateText(texts, targetLang, url, sourceId) {
  let locale = $('html').attr('lang');
  if (locale === 'pt-BR') {
    locale = 'pt'
  }
  const filteredTexts = texts.filter(text => text?.trim());
  if (filteredTexts.length === 0) return texts;

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      targetLang: locale,
      sourceLang: "en",
      sourceId: sourceId,
      filteredTexts: filteredTexts
    })
  });

  const data = await response.json();
  return data;
}
async function translateElements(whitelist, targetLang, isAntiqua, url, sourceId) {
  const elements = [];
  const metaElements = []; // for <meta> tags only

  whitelist.forEach(item => {
    if (item.value === "meta") {
      document.querySelectorAll('meta[name="description"]').forEach(el => metaElements.push(el));
    } else {
      document.querySelectorAll(item.value).forEach(el => elements.push(el));
    }
  });

  // Handle meta tags
  if (metaElements.length > 0) {
    const metaTexts = metaElements.map(el => el.getAttribute('content'));
    const translatedMeta = await translateText(metaTexts, targetLang, url, sourceId);

    metaElements.forEach((el, i) => {
      if (translatedMeta[i]) {
        el.setAttribute('content', translatedMeta[i]);
      }
    });
  }

  // Handle regular DOM elements as before
  const allTextNodes = [];
  const textContents = [];
  const whitespaceInfo = [];

  if (isAntiqua) {
    await new Promise(resolve => setTimeout(resolve, 1000));
    for (const el of elements) {
      const shadow = el.shadowRoot;
      if (!shadow) continue;
      const slot = shadow.querySelector('slot');
      if (!slot) continue;
      const nodes = slot.assignedNodes({ flatten: true });
      nodes.forEach(node => {
        const textNodes = getTextNodesPreserveWhitespace(node);
        textNodes.forEach(textNode => {
          const originalText = textNode.nodeValue;
          const leadingSpaces = originalText.match(/^\s*/)?.[0] || '';
          const trailingSpaces = originalText.match(/\s*$/)?.[0] || '';
          const trimmedText = originalText.trim();

          whitespaceInfo.push({ leadingSpaces, trailingSpaces });
          allTextNodes.push(textNode);
          textContents.push(trimmedText);
        });
      });
    }
  } else {
    elements.forEach(el => {
      const nodes = getTextNodesPreserveWhitespace(el);
      nodes.forEach(node => {
        const originalText = node.nodeValue;
        const leadingSpaces = originalText.match(/^\s*/)?.[0] || '';
        const trailingSpaces = originalText.match(/\s*$/)?.[0] || '';
        const trimmedText = originalText.trim();

        whitespaceInfo.push({ leadingSpaces, trailingSpaces });
        allTextNodes.push(node);
        textContents.push(trimmedText);
      });
    });
  }

  const translated = await translateText(textContents, targetLang, url, sourceId);

  allTextNodes.forEach((node, i) => {
    if (translated[i]) {
      const { leadingSpaces, trailingSpaces } = whitespaceInfo[i];
      node.nodeValue = leadingSpaces + translated[i] + trailingSpaces;
    }
  });

  // Localize myfonts.com URLs in translated elements
  const locale = $('html').attr('lang');
  elements.forEach(element => {
    localizeMyfontsUrls(element, locale);
  });
}
